import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import { toast } from "react-toastify";
import Select from 'react-select';
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminCustomSelect from "../../../components/CommonComponents/AdminCustomSelect";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";
import { getItemToken } from "../../../Utils/localStorageUtils";

function MenuAddUpdate() {

    const { fetchRequest, globalImageUplaodAPI } = useMyContext()

    const baseURL = process.env.REACT_APP_Baseurl
    const editApi = `${baseURL}/admin/menu/edit`
    const storeApi = `${baseURL}/admin/menu/store`
    const imageApi = globalImageUplaodAPI()
    const updateApi = `${baseURL}/admin/menu/update`
    const createApi = `${baseURL}/admin/menu/create`


    const navigate = useNavigate()
    const { id } = useParams()
    const headers = getItemToken('access_token')
    const combinedRef = useRef({});
    const [formDataError, setFormDataError] = useState({})
    const [formData, setFormData] = useState({ name: "", url: "site_url", in_menu: 0, in_side_menu: 0, custom_url: "", select_url: "", parent_id: 0, type: "", });
    const [showOverlay, setShowOverlay] = useState(false);
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [loading, setLoading] = useState(false);
    const [defaultOption, setDefaultOption] = useState({
        state: "defaultOption",
    })
    const [darkImageFile, setDarkImageFile] = useState('');
    const [lightImageFile, setLightImageFile] = useState('');
    const [customFieldValues, setCustomFieldValues] = useState({});

    const multiSelectLabel = (array, valueKey, labelKey) => {
        return Array.isArray(array) ? array?.map((item) => ({
            value: item[valueKey],
            label: item[labelKey]
        })) : [];
    };

    const formValidation = () => {
        let formIsValid = true;
        if (!formData?.name) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                name: "Name cannot be empty.",
            }));
            combinedRef.current['name'].focus()
            formIsValid = false;
        }
        if (formData?.url == "site_url" && !formData?.select_url) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                select_url: "Site url cannot be empty.",
            }));
            combinedRef.current['select_url'].focus()
            formIsValid = false;
        }
        if (formData?.url == "custom_url" && !formData?.custom_url) {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                custom_url: "Custom url cannot be empty.",
            }));
            combinedRef.current['custom_url'].focus()
            formIsValid = false;
        }
        return formIsValid;
    }

    const handleStore = (e) => {
        e.preventDefault()
        if (formValidation()) {
            if (!id) {
                handleAdd()
            }
            else {
                handleUpdate()
            }
        }
        else {
            console.table("validation")
        }
    }

    const handleFileUpload = async (id, name) => {
        try {
            const formDataAdd = new FormData();
            const imageFields = [];
            if (name == 'icon') {
                formDataAdd.append('image', lightImageFile)
                formDataAdd.append('dark_mode_image', darkImageFile)
                formDataAdd.append('id', id);
                formDataAdd.append('modelName', 'Menu');
                imageFields.push('image', 'dark_mode_image')
                imageFields.forEach((field) => {
                    formDataAdd.append('imageFields[]', field);
                });
                const response = await fetchRequest({
                    method: 'POST',
                    url: `${imageApi}`,
                    params: {},
                    data: formDataAdd,
                })
            }
            setDarkImageFile(null)
            setLightImageFile(null)
        } catch (err) {
            toast.error(err?.response?.data?.message)
        }
    }

    const handleAdd = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["parent_id", "order", "in_menu", "active", "in_icon", "name", "url", "type", "select_url", "custom_url", "in_side_menu", "in_menu"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            formDataAdd["sub_categories"] = formData?.selected_sub_categories?.map((item) => item?.value).join(",")
            const response = await fetchRequest({
                method: 'POST',
                url: `${storeApi}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                // save custom field values (strict)
                try {
                    await saveCustomFieldsStrict({ baseURL, headers, entityType: 'menu', entityId: result?.id, values: customFieldValues });
                } catch (e) {
                    toast.error(e?.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                if (darkImageFile || lightImageFile) {
                    await handleFileUpload(result?.id, 'icon')
                }
                setWithOutRefresh(!withOutRefresh)
                toast.success(result?.message)
                navigate("/menu")
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false);
        }
    }

    const handleUpdate = async () => {
        setShowOverlay(true);
        try {
            const formDataAdd = {};
            for (const key in formData) {
                if (["parent_id", "order", "in_menu", "active", "in_icon", "name", "url", "type", "select_url", "custom_url", "in_side_menu", "in_menu"].includes(key)) {
                    formDataAdd[key] = formData[key]
                }
            }
            formDataAdd["sub_categories"] = formData?.selected_sub_categories?.map((item) => item?.value).join(",")
            const response = await fetchRequest({
                method: 'PATCH',
                url: `${updateApi}/${id}`,
                params: {},
                data: formDataAdd,
            })
            const result = response;
            if (result?.status) {
                // save custom field values (strict)
                try {
                    await saveCustomFieldsStrict({ baseURL, headers, entityType: 'menu', entityId: id, values: customFieldValues });

                } catch (e) {
                    toast.error(e?.message || 'Failed to save additional fields');
                    setShowOverlay(false);
                    return;
                }
                if (darkImageFile || lightImageFile) {
                    await handleFileUpload(result?.id, 'icon')
                }
                toast.success(result?.message)
                setWithOutRefresh(!withOutRefresh)
            }
        }
        catch (err) {
            const errorMessage = err?.response?.data?.message
            toast.error(errorMessage)
        }
        finally {
            setShowOverlay(false)
        }
    }

    const handleInput = (e) => {
        const { name, type, value, checked } = e.target;
        if (type === 'checkbox') {
            setFormData((prevEditUser) => ({
                ...prevEditUser,
                [name]: checked ? 1 : 0,
            }));
        }
        if (type == "text" || type === 'select-one') {
            setFormData((prevEditUser) => ({
                ...prevEditUser,
                [name]: value,
            }));
            if (name == "type") {
                setFormData((prevEditUser) => ({
                    ...prevEditUser,
                    selected_sub_categories: []
                }));
            }
        }
        if (formData?.url == "site_url") {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                custom_url: "",
            }));
        }
        if (formData?.url == "custom_url") {
            setFormDataError((prevFormData) => ({
                ...prevFormData,
                select_url: "",
            }));
        }

        setFormDataError((prevEditUser) => ({
            ...prevEditUser,
            [name]: '',
        }));
    }

    const handleFileChange = async (event) => {
        const { files, name, value, accept } = event.target
        setFormDataError((prev) => ({
            ...prev,
            [name]: "",
        }));

        if (files?.length > 0) {
            const newFile = files[0];
            const reader = new FileReader();
            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            };
            const fileContent = await readFile(newFile);

            if (name == 'dark') {
                setDarkImageFile(newFile);
            }

            if (name == 'light') {
                setLightImageFile(newFile);

            };
        }
    }

    const handleClearSelectFile = (value) => {
        if (value == 'dark') {
            setDarkImageFile(null)
        }
        if (value == 'light') {
            setLightImageFile(null)
        }
    }

    const handleMultiSelect = (selectedOptions, actionMeta) => {
        setFormData((prev) => ({
            ...prev,
            [actionMeta.name]: selectedOptions
        }))
        setFormDataError((prev) => ({
            ...prev,
            [actionMeta.name]: ""
        }))
    }

    useEffect(async () => {
        if (id) {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${editApi}/${id}`,
                params: {},
                data: {},
            })
                .then(response => {
                    if (response?.status) {
                        setFormData((prev) => ({
                            ...prev,
                            ...response?.menu,
                            selected_sub_categories: multiSelectLabel(response?.selected_sub_categories, 'id', 'name'),
                        }));

                        setDefaultOption((prev) => ({
                            ...prev,
                            categoryOption: response.categories,
                            video_categories: multiSelectLabel(response?.video_categories, 'id', 'name'),
                            audios_categories: multiSelectLabel(response?.audios_categories, 'id', 'name'),
                            live_categories: multiSelectLabel(response?.live_categories, 'id', 'name'),
                            series_categories: multiSelectLabel(response?.series_categories, 'id', 'name'),
                            languages: multiSelectLabel(response?.languages, 'id', 'name'),

                        }))
                    }
                }).catch((error => {
                    toast.error(error?.response?.data?.message)
                })).finally(() => {
                    setLoading(false)
                })
        }
        else {
            setLoading(true)
            await fetchRequest({
                method: 'GET',
                url: `${createApi}`,
                params: {},
                data: {},
            })
                .then(response => {
                    if (response?.status) {
                        setDefaultOption((prev) => ({
                            ...prev,
                            categoryOption: response.categories,
                            video_categories: multiSelectLabel(response?.video_categories, 'id', 'name'),
                            audios_categories: multiSelectLabel(response?.audios_categories, 'id', 'name'),
                            live_categories: multiSelectLabel(response?.live_categories, 'id', 'name'),
                            series_categories: multiSelectLabel(response?.series_categories, 'id', 'name'),
                            languages: multiSelectLabel(response?.languages, 'id', 'name'),

                        }))
                    }
                }).catch((error => {
                    toast.error(error?.response?.data?.message)
                })).finally(() => {
                    setLoading(false)
                })
        }
    }, [withOutRefresh]);

    if (loading) {
        return <Defaultloadinggif className={"heightOnLoader"} />
    }

    return (
        <>
            {showOverlay && <Response_Processing></Response_Processing>}
            <AdminBackNavigation path={`/menu`} text="Back" />
            <AdminSaveHeader heading={id ? "Edit Menu" : "Add Menu"} saveText={id ? "Update Menu" : "Save Menu"} saveMethod={handleStore} loading={showOverlay} />
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageHeading text={id ? "Update Menu" : "Create Menu"} />
                        <MessageLabel text="Menu Name" className="mandatorySimple" />
                        <AdminCustomInput type="text" name="name" value={formData?.name} onChange={handleInput} placeHolder={"Enter name"} ref={(el) => (combinedRef.current.name = el)} error={formDataError?.name} />
                        <MessageLabel text="Menu Item URL" className="mandatorySimple" />
                        <AdminCustomSelect name="url" value={formData?.url} onChange={handleInput} ref={(el) => (combinedRef.current.url = el)} options={[{ name: "Site Url", value: "site_url" }, { name: "Custom Url", value: "custom_url" }]} error={formDataError?.url} defaultOptionName={""} />
                        {formData?.url == "site_url" &&
                            <>
                                <MessageLabel text="Menu Item URL" className="mandatorySimple" />
                                <AdminCustomInput type="text" name="select_url" value={formData?.select_url} onChange={handleInput} placeHolder={"Enter site url"} ref={(el) => (combinedRef.current.select_url = el)} error={formDataError?.select_url} appendText={`${process.env.REACT_APP_Baseurl_Frontend}/`} />
                            </>
                        }
                        {formData?.url == "custom_url" && <><MessageLabel text="Custom URL (ex. https || http)" className="mandatorySimple" />
                            <AdminCustomInput type="text" name="custom_url" value={formData?.custom_url} onChange={handleInput} placeHolder={"Enter custom url"} ref={(el) => (combinedRef.current.custom_url = el)} error={formDataError?.custom_url} />
                        </>}

                        <MessageLabel text="Dropdown for category" className="" />
                        <AdminCustomSelect name="type" value={formData?.type} onChange={handleInput} ref={(el) => (combinedRef.current.type = el)} options={defaultOption?.categoryOption?.map((item) => ({ name: item?.name, value: item?.value }))} error={formDataError?.type} defaultOptionName={""} />
                        <MessageLabel text="Dropdown for sub category" className="" />
                        <Select options={defaultOption?.[formData?.type]} isMulti name={'selected_sub_categories'} ref={(el) => (combinedRef.current.selected_sub_categories = el)} onChange={handleMultiSelect} value={formData?.selected_sub_categories} className={`${formDataError?.selected_sub_categories && 'custom-input-error'} custom-select-multi custom-placeholder theme-text-color mb-3`} noOptionsMessage={() => `Balance no data found ${formData?.type?.replace(/_/g, " ")}`} />

                        <div className="card p-3 mt-3">
                            {/* <MessageHeading text="Additional Fields" /> */}
                            {/* Custom fields removed */}
                            <FieldRenderer2
                                pageIdentifier={id ? "menu.edit" : "menu.create"}
                                entityType="menu"
                                entityId={id}
                                text="Additional Fields"
                            />
                            <FieldRenderer
                                pageIdentifier={id ? "menu.edit" : "menu.create"}
                                entityType="menu"
                                entityId={id}
                                onChange={setCustomFieldValues}
                            />
                        </div>


                    </Wrapper>

                    <Wrapper>
                        <MessageHeading text="Status Settings" />
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Show In Home"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'in_menu'} checked={formData?.in_menu == 1} onChange={handleInput} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Menu Status"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'active'} checked={formData?.active == 1} onChange={handleInput} />
                            </div>
                        </div>
                        <div className="d-flex justify-content-between mb-2 ">
                            <div className="col-6 col-md-6 pe-2">
                                <MessageLabel text={"Icon Status"} />
                            </div>
                            <div className="col-6 col-md-6 ps-2 text-end">
                                <AdminSwitch name={'in_icon'} checked={formData?.in_icon == 1} onChange={handleInput} />
                            </div>
                        </div>

                        {/* <div className="row mx-0">
                <div className="col-9 ps-0">
                  <MessageLabel text="Show In SideMenu " />
                </div>
                <div className="col-3 text-end">
                  <label className="switch">
                    <input name="in_side_menu" onChange={handleInput} checked={formData?.in_side_menu === 1} type="checkbox" className="rs-input" />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div> */}
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text='Menu Icon' />
                        <MessageLabel text="Dark Mode" />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={darkImageFile}
                            uploadedImage={formData?.dark_mode_image}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.dark_mode_image = el)}
                            name="dark"
                            id={id}
                            error={formDataError?.dark_mode_image}
                        />
                        <MessageLabel text="Light Mode" />
                        <AdminImageUploadZone
                            onChange={handleFileChange}
                            selectedFile={lightImageFile}
                            uploadedImage={formData?.image}
                            onDelete={handleClearSelectFile}
                            ref={(el) => (combinedRef.current.image = el)}
                            name="light"
                            id={id}
                            error={formDataError?.image}
                        />
                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton saveMethod={handleStore} type="submit" saveText={id ? "Update Menu" : "Save Menu"} className="ms-auto" loading={showOverlay} />
            </FormContainer>
        </>
    );
}
export default MenuAddUpdate;